import Cookies from 'js-cookie';
import type { QueryClient } from '@tanstack/react-query';
import type { SessionEndReason } from './sessionSecurity';

type Dependencies = {
  queryClient: QueryClient;
  dispatch: (action: { type: string }) => unknown;
  clearSdk: () => void;
  disconnect: () => void;
  redirect: (path: string) => void;
};
const devicePreferences = new Set([
  'printer',
  'printerPaperSize',
  'labelPrinter',
  'labelPrinterSize',
  'i18nextLng',
  'washday:attendanceDeviceId'
]);

export function clearSessionData(dependencies: Dependencies, reason: SessionEndReason) {
  const { queryClient, dispatch, clearSdk, disconnect, redirect } = dependencies;
  ['token', 'userID', 'stripeCustomerId', 'currencySymbol'].forEach((key) => Cookies.remove(key));
  // Keep hardware/language preferences; remove drafts, company caches and paired display secrets.
  try {
    Object.keys(localStorage).forEach((key) => {
      if (!devicePreferences.has(key)) localStorage.removeItem(key);
    });
    sessionStorage.clear();
  } catch {
    /* Storage can be unavailable; in-memory teardown must still complete. */
  }
  disconnect();
  clearSdk();
  void queryClient.cancelQueries();
  queryClient.clear();
  dispatch({ type: 'CLEAR_USER' });
  // A new document also discards component state and third-party in-memory data.
  redirect(reason === 'logout' ? '/' : `/?session=${reason}`);
}
